export default "__VITE_ASSET__NZrRfXKq__"